import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale:'fr',
    fallbackLocale: 'fr',
    messages: {
        fr: { legende: 'Selectionnez un type de structures'},
        es: { legende: 'Seleccione un tipo de estructuras'},
        eu: { legende: 'Aukeratu egitura mota bat'},
    },
})


// WEBPACK FOOTER //
// ./scripts/i18n.js